import styled from 'styled-components';
import { formControlBase, formControlBaseSelect, formControlTheme } from "../../styles";
export var Select = styled.select.withConfig({
  displayName: "Select",
  componentId: "sc-3qvhho-0"
})(["", ";", ";", ";"], formControlBase(), formControlBaseSelect(), function (props) {
  return formControlTheme({
    isUsingKeyboard: props.isUsingKeyboard,
    isHover: props.isHover,
    isFocus: props.isFocus,
    error: props.error
  });
});